module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0015-425f25077c5b27de83ca65f651bd1b37.jpg";